import { Typography, Flex } from "antd";
import { useTranslate } from "@refinedev/core";
import { useAntTheme } from "hooks/useAntTheme";
import { Card } from "@libertify/ui";

export const VoiceCloneTextSample = ({
  textForRecording,
}: {
  textForRecording: string;
}) => {
  const t = useTranslate();
  const { theme } = useAntTheme();
  const sentences = textForRecording
    .split(/(?<=[.!?。！？])\s+/)
    .filter(Boolean);

  return (
    <Card
      styles={{
        body: {
          padding: 8,
          backgroundColor: theme.colorBgContainerDisabled,
          maxHeight: "30vh",
          overflowY: "auto",
        },
      }}
    >
      <Flex vertical gap={10}>
        <Typography.Text strong>
          {t("media.components.VoiceProfileCreateForm.readTextAloud")}
        </Typography.Text>
        {sentences.map((sentence, index) => (
          <Typography.Paragraph
            key={`${sentence}-${index}`}
            style={{ margin: 0 }}
          >
            {sentence}
          </Typography.Paragraph>
        ))}
      </Flex>
    </Card>
  );
};
